import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
      
const query = graphql`
query AccountInformationFetchQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountTByParentId {
        accountName
        logo
      }
    accountStatus
    accountType
    contactFirstName
    contactLastName
    contactEmail
    address1
    floatLimit
    autoTopupActive
    autoTopupAmount
    autoTopupThreshhold
    rAutoTopupAmount
    rAutoTopupThreshold
    rMaxCharge
    rMaxMonthlyBudget
    requestedMaxCharge
    requestedFloatLimit
    maxCharge
    payFromBalance
    maxMonthlyBudget
    useBudgets
    initialBalanceAmount
    paymentSourceTsByAccountId {
      nodes {
        psId
        psOrder
        extSource
        extPsId
        psType
        psStatus
      }
    }
  }
}
`;

function fetch(accountId) {
  const variables = {
    accountId: accountId
  }
  
  return fetchQuery(
    abEnvironment.getEnvironment(),
    query,
    variables
  );
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { fetch };

